import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { FormPostprocessorBuilderComponent } from './form-postprocessor-builder.component'
import { FormsModule } from '@angular/forms'
import { TranslateModule } from '@ngx-translate/core'
import { ContentEditableModule } from '@containers/i18n/content-editable/content-editable.module'
import { BrowserAnimationsModule } from '@angular/platform-browser/animations'
import { SharedModule } from '@shared/shared.module'
import { CardModule } from '@components/card/card.module'
import { HttpClientModule } from '@angular/common/http'
import { BrowserModule } from '@angular/platform-browser'
import { RouterModule } from '@angular/router'
import { PropertyTypeModalModule } from '@components/property-type-modal/property-type-modal.module'

@NgModule({
  declarations: [FormPostprocessorBuilderComponent],
  imports: [
    CommonModule,
    FormsModule,
    TranslateModule,
    ContentEditableModule,
    BrowserAnimationsModule,
    SharedModule,
    CardModule,
    HttpClientModule,
    BrowserModule,
    RouterModule.forRoot([]),
    PropertyTypeModalModule,
  ],
  exports: [FormPostprocessorBuilderComponent],
})
export class FormPostprocessorBuilderModule {}
